import {Button, Card, Col, Modal, Row, Select, Space} from "antd";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useAssignUserVerificationProfile} from "../../../../function/accountVerification";
import {useIsMobile} from "../../../../../../_common/function";
import {CaretDownFilled} from "@ant-design/icons";
import {countryList_language} from "../../../../../../../config/countryList_language";

function SelectCountry(props) {
    const {selectedCountry, setSelectedCountry, userVerificationProfile, goNext, getUserVerificationFlows} = props

    const {t} = useTranslation();
    const {assignUserVerificationProfile} = useAssignUserVerificationProfile();
    const isMobile = useIsMobile();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleSelectCountry = () => {
        if (userVerificationProfile?.country && selectedCountry !== userVerificationProfile?.country) {
            openModal()
        } else {
            goNext()
        }
    }

    const handleChangeCountryFlow = async () => {
        await getUserVerificationFlows({country: selectedCountry});
        goNext()
    }

    return (
        <>
            <Card bordered={false} className={"shadow-card"}>
                <Space style={{width: "100%"}} size={16} direction="vertical">
                    <div className={"mb-4"}>
                        <h6><strong>{t("accountVerification.selectCountry")}</strong></h6>
                        <p className={"secondary-text"}>{t("accountVerification.note.selectCountry")}</p>
                    </div>

                    <Row gutter={16} align={"middle"}>
                        <Col flex={1}>
                            <Select
                                style={{width: "100%"}}
                                showSearch
                                placeholder={t("accountVerification.placeholder.selectCountry")}
                                optionFilterProp={"label"}
                                value={selectedCountry}
                                onChange={(country) => setSelectedCountry(country)}
                                suffixIcon={<CaretDownFilled style={{pointerEvents: "none"}}/>}
                                options={countryList_language?.map(d => ({
                                    ...d,
                                    label: t(d?.label),
                                }))}
                            />
                        </Col>
                        <Col {...(isMobile ? {span: 24} : {flex: "50px"})}>
                            <Button
                                block
                                type="primary"
                                disabled={!selectedCountry}
                                onClick={handleSelectCountry}
                                className={isMobile ? "mt-4" : "!h-[39px]"}
                            >
                                {t("common.next")}
                            </Button>
                        </Col>
                    </Row>
                </Space>
            </Card>

            <Modal
                className="verification-modal"
                title={t("Change Country")}
                open={isModalOpen}
                onCancel={closeModal}
                destroyOnClose
                width={"400px"}
                getContainer="#layout-3"
                footer={
                    <Row justify={"end"} gutter={16}>
                        <Col>
                            <Button onClick={closeModal}>{t("common.cancel")}</Button>
                        </Col>
                        <Col>
                            <Button type="primary" onClick={handleChangeCountryFlow}>
                                {t("common.confirm")}
                            </Button>
                        </Col>
                    </Row>
                }
            >
                <div>{t("The selected country does not match your profile. Do you wish to continue?")}</div>
            </Modal>
        </>
    );
}

export default SelectCountry
